import     React, 
        {  useState, 
           useEffect, 
           useRef           }           from "react";
import {   useActionModal   }           from "components/Covers/confirmAction";
import {   useInfoMsgModal  }           from "components/Covers/infoMessageModal";
import {   InputGeneral     }           from "components/Field/field";
import     MainStyle                    from "components/UI/main.module.scss";
import     JSZip                        from "jszip";
import {   saveAs           }           from "file-saver";
import {   GetLabel         }           from "Utilities/utils";

let appLang = null;

const DefaultPadding = () =>{
    return(<div className={MainStyle.py_3}/>);
};
const LogoStandardizer = () => {
  const [   images,     setImages       ]   = useState([]);
  const [   canvasSize, setCanvasSize   ]   = useState({ width: 800, height: 570 });
  const     fileInputRef                    = useRef(null);
  const     idCounter                       = useRef(0);
  const {   showInfoMessage             }   = useInfoMsgModal();
  const {   showActionMessage           }   = useActionModal();

    useEffect(() => {
        document.documentElement.style.setProperty("--canvas-aspect-ratio",`${canvasSize.width} / ${canvasSize.height}`);
    }, [canvasSize]);

    const handleFiles = (files) => {
        const fileArray = Array.from(files);
        fileArray.forEach((file) => {
            if (!file.type.startsWith("image/")) return;

            const reader = new FileReader();
            reader.onload = (e) => {
                const img = new Image();
                img.onload = () => {
                    const ratio = Math.min(
                        (canvasSize.width * 0.95) / img.width,
                        (canvasSize.height * 0.95) / img.height
                    );
                    const id = idCounter.current++;
                    const fileName = file.name.replace(/\.[^.]+$/, "") + "_padronizado.png";
                    const state = {
                        scale: ratio,
                        offsetX: (canvasSize.width - img.width * ratio) / 2,
                        offsetY: (canvasSize.height - img.height * ratio) / 2,
                    };
                    setImages((prev) => [...prev, { id, fileName, img, state }]);
                };
                img.src = e.target.result;
            };
            reader.readAsDataURL(file);
        });
    };

    const triggerFileInput = () => {
        if (fileInputRef.current) {
            fileInputRef.current.click();
        }
    };

    const applyNewDimensions = () => {
        if (images.length === 0) {
            showInfoMessage({'header': GetLabel(appLang, 107), 'message': GetLabel(appLang, 157)});
            return;
        }
        else if (canvasSize.width > 999 || canvasSize.height > 999) {
            showInfoMessage({'header': GetLabel(appLang, 107), 'message': GetLabel(appLang, 158)});
            return;
        }
        showActionMessage({ header: GetLabel(appLang, 54), 
                            message: <>{GetLabel(appLang, 159)}</>},
                            { confirm_action: async () => {
                                        setImages((prev) =>
                                            prev.map(({ id, fileName, img }) => {
                                                const ratio = Math.min(
                                                (canvasSize.width * 0.95) / img.width,
                                                (canvasSize.height * 0.95) / img.height
                                                );
                                                return {
                                                id,
                                                fileName,
                                                img,
                                                state: {
                                                    scale: ratio,
                                                    offsetX: (canvasSize.width - img.width * ratio) / 2,
                                                    offsetY: (canvasSize.height - img.height * ratio) / 2,
                                                },
                                                };
                                            })
                                        );
                                }
                            }
        );
    };

    const renderPreview = (img, state) => {
        const canvas = document.createElement("canvas");
        canvas.width = canvasSize.width;
        canvas.height = canvasSize.height;
        const ctx = canvas.getContext("2d");
        ctx.drawImage(
            img,
            state.offsetX,
            state.offsetY,
            img.width * state.scale,
            img.height * state.scale
        );
        return canvas.toDataURL("image/png");
    };

    const downloadAllZip = async () => {
        if (images.length === 0) return;
        const zip = new JSZip();
        const canvas = document.createElement("canvas");
        canvas.width = canvasSize.width;
        canvas.height = canvasSize.height;
        const ctx = canvas.getContext("2d");

        for (let { img, state, fileName } of images) {
            ctx.clearRect(0, 0, canvas.width, canvas.height);
            ctx.drawImage(
                img,
                state.offsetX,
                state.offsetY,
                img.width * state.scale,
                img.height * state.scale
            );
            const blob = await new Promise((resolve) =>
                canvas.toBlob(resolve, "image/png")
            );
            zip.file(fileName, blob);
        }

        const zipContent = await zip.generateAsync({ type: "blob" });
        saveAs(zipContent, "logos.zip");
    };

  return (
    <div className={MainStyle.mx_3}>
        <DefaultPadding/>
        <div className={MainStyle.row}>
            <div className={MainStyle.col_lg}>
                <span className={MainStyle.text_body}>
                    {GetLabel(appLang, 160)}
                </span>
            </div>
            <div className={MainStyle.col_lg}>
                <div    onClick={triggerFileInput}
                        onDragOver={(e) => e.preventDefault()}
                        onDrop={(e) => {
                                e.preventDefault();
                                handleFiles(e.dataTransfer.files);
                        }}
                        style={{cursor:'pointer'}} 
                        className={[MainStyle.d_flex, MainStyle.justify_content_center].join(" ")}>
                    <label  className={[MainStyle.btn_upload, 
                                        MainStyle.rounded_5, 
                                        MainStyle.border, 
                                        MainStyle.shadow_sm,
                                        MainStyle.text_center].join(" ")} 
                    >
                        <svg 
                            xmlns="http://www.w3.org/2000/svg" 
                            viewBox="0 0 448 512"
                            style={{width: '80%', height: 'auto'}}
                            className={MainStyle.my_2}
                        >
                            <path 
                                d="M246.6 9.4c-12.5-12.5-32.8-12.5-45.3 0l-128 128c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 109.3 192 320c0 17.7 14.3 32 32 32s32-14.3 32-32l0-210.7 73.4 73.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-128-128zM64 352c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 64c0 53 43 96 96 96l256 0c53 0 96-43 96-96l0-64c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 64c0 17.7-14.3 32-32 32L96 448c-17.7 0-32-14.3-32-32l0-64z"
                            />
                        </svg>
                    </label>
                    <input style={{ display: 'none'}} type="file" ref={fileInputRef} onChange={(e) => handleFiles(e.target.files)}/>
                </div>
            </div>            
        </div>
        
        <div className={MainStyle.row}>
            <div className={MainStyle.col_lg}>
                <div className={MainStyle.mx_2}>
                    <p className={MainStyle.text_body}>
                        {GetLabel(appLang, 161)}:
                    </p>
                    <InputGeneral 
                        type="number"
                        value={canvasSize.width}
                        className={[MainStyle.fs_6, MainStyle.text_input, MainStyle.border_1, MainStyle.mb_3].join(" ")} 
                        onChange={(e) =>
                            setCanvasSize((prev) => ({ ...prev, width: parseInt(e.target.value) || 1 }))
                        }
                        placeholder={GetLabel(appLang, 161)}
                    />
                </div>
            </div>
            <div className={MainStyle.col_lg}>
                <div className={MainStyle.mx_2}>
                    <p className={MainStyle.text_body}>
                        {GetLabel(appLang, 162)}:
                    </p>
                    <InputGeneral 
                        type="number"
                        value={canvasSize.height}
                        className={[MainStyle.fs_6, MainStyle.text_input, MainStyle.border_1, MainStyle.mb_3].join(" ")} 
                        onChange={(e) =>
                            setCanvasSize((prev) => ({ ...prev, height: parseInt(e.target.value) || 1 }))
                        }
                        placeholder={GetLabel(appLang, 162)}
                    />
                </div>
            </div>
        </div>

        <div className={MainStyle.row}>
            {images?.length > 0 && (
                <div className={MainStyle.col_lg}>
                    <div className={MainStyle.mx_2}>
                        <div className={[MainStyle.d_flex, MainStyle.justify_content_center].join(" ")}>
                            <button onClick={()=> { setImages([]);}}
                                    style={{ width: '70%' }}
                                    disabled={images.length === 0}
                                    className={[MainStyle.text_center,
                                                MainStyle.btn_blue, 
                                                MainStyle.border, 
                                                MainStyle.shadow_sm, 
                                                MainStyle.fs_6,
                                                MainStyle.text_white,
                                                MainStyle.rounded_3].join(" ")} 
                            >
                                <div className={[MainStyle.my_3].join(" ")}>
                                    <span>{GetLabel(appLang, 163)}</span>
                                </div>
                            </button>
                        </div>
                    </div>
                </div>
            )}            
            <div className={MainStyle.col_lg}>
                <div className={MainStyle.mx_2}>
                    <div className={[MainStyle.d_flex, MainStyle.justify_content_center].join(" ")}>
                        <button onClick={applyNewDimensions}
                                style={{ width: '70%' }}
                                className={[MainStyle.text_center,
                                            MainStyle.btn_blue, 
                                            MainStyle.border, 
                                            MainStyle.shadow_sm, 
                                            MainStyle.fs_6,
                                            MainStyle.text_white,
                                            MainStyle.rounded_3].join(" ")} 
                        >
                            <div className={[MainStyle.my_3].join(" ")}>
                                <span>{GetLabel(appLang, 586)}</span>
                            </div>
                        </button>
                    </div>
                </div>
            </div>
            {images?.length > 0 && (
                <div className={MainStyle.col_lg}>
                    <div className={MainStyle.mx_2}>
                        <div className={[MainStyle.d_flex, MainStyle.justify_content_center].join(" ")}>
                            <button onClick={downloadAllZip}
                                    style={{ width: '70%' }}
                                    disabled={images.length === 0}
                                    className={[MainStyle.text_center,
                                                MainStyle.btn_blue, 
                                                MainStyle.border, 
                                                MainStyle.shadow_sm, 
                                                MainStyle.fs_6,
                                                MainStyle.text_white,
                                                MainStyle.rounded_3].join(" ")} 
                            >
                                <div className={[MainStyle.my_3].join(" ")}>
                                    <span>{GetLabel(appLang, 164)}</span>
                                </div>
                            </button>
                        </div>
                    </div>
                </div>
            )}      
        </div>
          <DefaultPadding/>
          {images?.map(({ id, fileName, img, state }) => (
            <div key={id} className={MainStyle.row}>
                <div className={MainStyle.col}>
                    <div className={MainStyle.mx_3}>
                        <div key={id} className={MainStyle.row}>
                            <div className={MainStyle.col_lg}>
                                <div style={{height: '100%'}} className={[MainStyle.d_flex, MainStyle.align_items_center, MainStyle.justify_content_center].join(" ")}>
                                    <p className={MainStyle.text_body}>
                                        {fileName}
                                    </p>
                                </div>
                            </div>
                            <div className={MainStyle.col_lg}>
                                <img    className={MainStyle.bg_transparent_chess}
                                        src={renderPreview(img, state)}
                                        alt={fileName}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
          ))}
    </div>
  );
};
export const ImageResizerPage = () => {
    return (
        <div className={MainStyle.row}>
            <div className={MainStyle.col_lg}>
                <DefaultPadding/>
                <div className={MainStyle.mx_3}>
                    <div className={[MainStyle.bg_card, 
                                    MainStyle.shadow, 
                                    MainStyle.border, 
                                    MainStyle.rounded].join(" ")}>
                        <div className={[MainStyle.m_3].join(" ")}>
                            <span className={[MainStyle.fs_5, MainStyle.text_body, MainStyle.fw_semibold].join(" ")}>
                                {GetLabel(appLang, 165)}
                            </span>
                        </div>

                        <div className={[MainStyle.bg_card_inner,
                                        MainStyle.border_top,
                                        MainStyle.border_bottom,
                                        MainStyle.border_end].join(" ")}>
                            
                            <LogoStandardizer/>
                            <DefaultPadding/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};